import { useTranslation } from 'react-i18next';

import { cn } from 'utils/cn';
import { formatSwissNumber } from 'utils/formatNumber';

import { Cell } from './Cell';

import { pdfColumnWidth } from '.';

export const TotalRow = ({
  totals,
  isPDF,
}: {
  totals: {
    totalGainPrice: number;
    totalN: string;
    totalP: string;
    totalK: string;
    totalNPK: number;
    totalMonsp: number;
    totalTotal: number;
  };
  isPDF?: boolean;
}) => (
  <div
    className={cn('flex p-4 divide-x divide-transparent text-sm', {
      'text-xs': isPDF,
    })}
  >
    <Cell
      isPDF={isPDF}
      pdfWidth={pdfColumnWidth['1']}
      defaultWidth="w-[160px]"
      className="font-bold"
    >
      {useTranslation().t('total')}
    </Cell>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['2']]: isPDF })}>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/2"
        defaultWidth="w-[80px]"
        className="flex justify-center font-bold"
      >
        -
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/2"
        defaultWidth="w-[80px]"
        className="flex justify-center font-bold"
      >
        -
      </Cell>
    </div>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['3']]: isPDF })}>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/3"
        defaultWidth="w-[100px]"
        className="font-bold"
      >
        -
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/3"
        defaultWidth="w-[100px]"
        className="font-bold"
      >
        -
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/3"
        defaultWidth="w-[100px]"
        className="font-bold"
      >
        -
      </Cell>
    </div>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['2']]: isPDF })}>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/2"
        defaultWidth="w-[60px]"
        className="font-bold"
      >
        -
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/2"
        defaultWidth="w-[60px]"
        className="font-bold"
      >
        {totals.totalGainPrice}
      </Cell>
    </div>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['3']]: isPDF })}>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/3"
        defaultWidth="w-[100px]"
        className="font-bold"
      >
        {totals.totalN}
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/3"
        defaultWidth="w-[100px]"
        className="font-bold"
      >
        {totals.totalP}
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/3"
        defaultWidth="w-[100px]"
        className="font-bold"
      >
        {totals.totalK}
      </Cell>
    </div>

    <Cell
      isPDF={isPDF}
      pdfWidth={pdfColumnWidth['1']}
      defaultWidth="w-[100px]"
      className="font-bold"
    >
      {formatSwissNumber(Math.round(Number(totals.totalNPK)))}
    </Cell>

    <Cell
      isPDF={isPDF}
      pdfWidth={pdfColumnWidth['1']}
      defaultWidth="w-[100px]"
      className="font-bold"
    >
      {formatSwissNumber(Math.round(Number(totals.totalMonsp)))}
    </Cell>

    <Cell
      isPDF={isPDF}
      pdfWidth={pdfColumnWidth['1']}
      defaultWidth="w-[100px]"
      className="font-bold"
    >
      {formatSwissNumber(Math.round(Number(totals.totalTotal)))}
    </Cell>
  </div>
);
